import {
  QuantityBadge,
  Text,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { Spacings, View } from "react-native-ui-lib";
import {
  SyncProgressEvent,
  SyncProgressStatus,
} from "../../../../utilities/setup/page-query";
import { SyncProgressBadge } from "../SyncProgressBadge";
import { toTitleCase } from "@towersystems/roam-common/lib/shared-utils";

type SyncListItemType = {
  name: string;
  progress: SyncProgressEvent;
};

const COLUMN_COMPACT_WIDTH = 80;

export function SyncProgressListItem({ name, progress }: SyncListItemType) {
  const { colors } = useThemeProvider();

  const colorStyles = {
    color: colors.Text,
  };

  const columnWidth = COLUMN_COMPACT_WIDTH;

  const columnStyle = {
    alignItems: "center",
    width: columnWidth,
    justifyContent: "flex-end",
  } as const;

  const defaultSyncStatus = SyncProgressStatus.FETCHING;

  return (
    <View
      flex
      row
      style={{
        paddingVertical: Spacings.s4,
      }}
    >
      <View
        row
        style={{ alignItems: "center", flexBasis: "100%", flexShrink: 1 }}
      >
        <View style={{ flexShrink: 1 }}>
          <Text
            variant="heading1"
            style={colorStyles}
            numberOfLines={1}
            ellipsizeMode="head"
          >
            {toTitleCase(name.split("_").join(" "))}
          </Text>
        </View>
      </View>

      <View row style={columnStyle}>
        <Text>{`${progress.fetched}/${
          progress.estimatedTotalItems ?? 0
        }`}</Text>
      </View>

      <View row style={columnStyle}>
        <SyncProgressBadge
          label={progress?.status || defaultSyncStatus}
          status={progress?.status || defaultSyncStatus}
        />
      </View>
    </View>
  );
}
